<template>
  <div class="flex items-center justify-center">
    <img
      src="https://cdn.platform.bostello.com/assets/bostello-admin-logo.svg"
      alt="Bostello Admin"
      :class="logoClasses"
      @error="handleImageError"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue'

  interface Props {
    size?: 'sm' | 'md' | 'lg' | 'xl'
    className?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    size: 'md',
    className: '',
  })

  const hasError = ref(false)

  const logoClasses = computed(() => {
    const sizeClasses = {
      sm: 'h-8 w-auto',
      md: 'h-12 w-auto',
      lg: 'h-16 w-auto',
      xl: 'h-20 w-auto',
    }

    return `${sizeClasses[props.size]} ${props.className}`
  })

  const handleImageError = () => {
    hasError.value = true
    console.error('Failed to load Bostello logo')
  }
</script>
